import type { ValueOf } from './util/typeUtils';

export const MAIL_STATUS_RETRIES = 15;

export const MAIL_STATUS_RETRY_INTERVAL = 500;

export const ETA_TEMPLATE_OPENING_TAG = '<%';

export const MAIL_CONTENT_KINDS = {
    MAIL_CONTENT: 'mailContent',
    MAIL_HTML_CONTENT: 'mailHTMLContent',
} as const;

export type MAIL_CONTENT_KIND = ValueOf<typeof MAIL_CONTENT_KINDS>;

export const MAIL_RENDER_TYPES = {
    HTML: 'html',
    TEXT: 'text',
} as const;

export type MAIL_RENDER_TYPE = ValueOf<typeof MAIL_RENDER_TYPES>;

export const CORPORATION_MAIL_CONTACT = {
    email: 'mail@kredit.de',
    firstName: 'Ihr',
    lastName: 'KREDIT.DE Team',
    phone: '+49 800 9998870',
} as const;
